import { render } from "./AmazonCatalog.vue?vue&type=template&id=5b1bf137"
import script from "./AmazonCatalog.vue?vue&type=script&lang=js"
export * from "./AmazonCatalog.vue?vue&type=script&lang=js"

import "./AmazonCatalog.vue?vue&type=style&index=0&id=5b1bf137&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__